import type { AvatarUser } from '@core/account-ui';
import type { TellentMemberBrief } from '@core/ask-hr-types';
import { getInitials } from '@core/utils-legacy';

export interface MinimalMember {
  firstName: string;
  lastName: string;
  avatarThumbUrl?: string | null;
}

export const toMemberBrief = (member: MinimalMember): TellentMemberBrief => ({
  guid: '',
  userGuid: '',
  email: '',
  owner: false,
  status: 'active',
  abilities: [],
  firstName: member.firstName,
  lastName: member.lastName,
  avatarThumbUrl: member.avatarThumbUrl ?? null,
});

export const assigneeToAvatarUser = (assignee: TellentMemberBrief): AvatarUser => ({
  id: assignee.userGuid,
  firstName: assignee.firstName,
  lastName: assignee.lastName,
  initials:
    assignee.status === 'deactivated' ? '' : getInitials(assignee.firstName, assignee.lastName),
  hasAvatar: !!assignee.avatarThumbUrl,
  photoThumbUrl: assignee.avatarThumbUrl || '',
});
